import { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { Award, Loader2, XCircle } from "lucide-react";

export default function FoundersSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const { refreshUser } = useAuth();
  const [state, setState] = useState({ loading: true, paid: false });
  const attempts = useRef(0);

  useEffect(() => {
    if (!sid) { setState({ loading: false, paid: false }); return; }
    let cancel = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/founders/status/${sid}`);
        if (cancel) return;
        if (data.payment_status === "paid") {
          await refreshUser();
          setState({ loading: false, paid: true });
          return;
        }
        if (attempts.current >= 8 || data.status === "expired") {
          setState({ loading: false, paid: false });
          return;
        }
        attempts.current += 1;
        setTimeout(poll, 2000);
      } catch {
        if (!cancel) setState({ loading: false, paid: false });
      }
    };
    poll();
    return () => { cancel = true; };
  }, [sid, refreshUser]);

  return (
    <div className="max-w-2xl mx-auto px-6 py-24 text-center" data-testid="founders-success-page">
      {state.loading && (
        <>
          <Loader2 className="w-12 h-12 mx-auto animate-spin text-[#002855]" />
          <h1 className="mt-6 font-display text-3xl text-[#0A192F]">Confirming your membership…</h1>
        </>
      )}
      {!state.loading && state.paid && (
        <>
          <Award className="w-14 h-14 mx-auto text-[#C5A059]" />
          <div className="label-eyebrow mt-6 text-[#C5A059]">Welcome to the Circle</div>
          <h1 className="mt-3 font-display text-4xl text-[#0A192F]">You're now a Founders' Circle member.</h1>
          <p className="mt-4 text-slate-600">Your lapel pin will ship within 2–3 weeks. The Members Directory is now unlocked.</p>
          <div className="mt-10 flex gap-3 justify-center">
            <Link to="/directory"><Button className="bg-[#002855] hover:bg-[#0A192F] text-white rounded-md">Open the Directory</Button></Link>
            <Link to="/feed"><Button variant="outline" className="border-slate-200 rounded-md">Back to the feed</Button></Link>
          </div>
        </>
      )}
      {!state.loading && !state.paid && (
        <>
          <XCircle className="w-14 h-14 mx-auto text-[#9B111E]" />
          <h1 className="mt-6 font-display text-3xl text-[#0A192F]">Payment not completed</h1>
          <Link to="/founders"><Button className="mt-6 bg-[#002855] hover:bg-[#0A192F] text-white rounded-md">Return to Founders' Circle</Button></Link>
        </>
      )}
    </div>
  );
}
